import axios, {AxiosError} from "axios";
import * as Endpoints from './endpoints';
import BaseService from "./base-service";

import {ACCEPT_HEADER, CONTENT_TYPE_HEADER, GRAPHQL_ENDPOINT_HEADER} from "./headers";
import {buildIntrospectionRequestPayload} from './graphql-queries';
import {GraphQlSchema} from "../types/GraphQlSchema";
import {parseGqlSchema} from "./mappers/graphql-schema-mapper";
import { buildClientSchema, getIntrospectionQuery } from "graphql";

const DEFAULT_QUERY_CONFIG = {
  headers: {
    [ACCEPT_HEADER]: 'application/json',
    [CONTENT_TYPE_HEADER]: 'application/json'
  }
};

/**
 * GraphQL service for executing queries and mutations.
 */
export default class GraphQLService extends BaseService {

  static getQueryExecutor(endpointHeader: string) {
    // memoize the config with the endpoint until next change is needed
    const config = this.buildConfig(endpointHeader);
    // this function will use one and the same config from the closure
    return (graphQLParams: any) => {
      return axios.post(Endpoints.GRAPHQL, JSON.stringify(graphQLParams), config)
        .then(BaseService.resolveResponse)
        .catch(GraphQLService.resolveQueryErrorResponse);
    }
  }

  /**
   * Performs schema introspection query for the specified endpoint.
   *
   * @param endpointHeader request header which determines the correct endpoint for the request
   */
  static executeSchemaIntrospection(endpointHeader: string): Promise<GraphQlSchema> {
    const payload = buildIntrospectionRequestPayload(endpointHeader);
    return axios.post(Endpoints.GRAPHQL, payload, this.buildConfig(endpointHeader))
      .then(BaseService.resolveResponse)
      .then(parseGqlSchema)
      .catch(GraphQLService.resolveQueryErrorResponse);
  }

  static graphqlIntrospection(endpoint: string) {
    return axios.post(Endpoints.GRAPHQL, {query: getIntrospectionQuery()}, this.buildConfig(endpoint)).then((response: any) => {
      return buildClientSchema(response.data.data);
    })
  }

  private static buildConfig(endpointHeader: string) {
    return {
      headers: {...DEFAULT_QUERY_CONFIG.headers, [GRAPHQL_ENDPOINT_HEADER]: endpointHeader}
    };
  }

  private static resolveQueryErrorResponse(errorResponse: AxiosError) {
    return Promise.reject(errorResponse.response ? errorResponse.response : errorResponse);
  }
}
